export enum PaymentMethod {  
  CHECK="1",
  DIRECT_DEPOSIT="2",  
  WIRE_TRANSFER="3",
  SEPA="4"
}